import { IconType } from "@common/declarations";
import { useVisibleModal } from "@common/lib/hooks";
import React from "react";
import { type BaseRange, Node } from "slate";
import { ReactEditor, useSlate } from "slate-react";
import MenuButtonBase from "../Buttons/Base";
import { fromHtml } from "../html";
import { isMenuButtonActive } from "../lib";
import { type MenuButtonPropsBase } from "../types";
import AiModal from "./Modal";

type VisibleModal = {
  selection: BaseRange | null;
  text: string;
};
const AiButton = (props: MenuButtonPropsBase) => {
  const editor = useSlate();

  const [visibleModal, setVisibleModal, hideVisibleModal] = useVisibleModal<VisibleModal>();

  const onClick = React.useCallback(() => {
    const { selection } = editor;

    const text = (selection ? editor.string(selection) : "").trim();

    setVisibleModal({ selection, text: text || Node.string(editor) });
  }, [editor, editor.selection]);

  const submit = React.useCallback(
    (text: string) => {
      ReactEditor.focus(editor);

      if (visibleModal?.selection) {
        editor.delete({
          at: visibleModal.selection
        });
      } else if (visibleModal?.text) {
        editor.deleteAll();
      }

      editor.insertFragment(fromHtml(text));

      hideVisibleModal();
    },
    [visibleModal, editor]
  );

  const onClose = React.useCallback(() => {
    if (visibleModal?.selection) {
      editor.select(visibleModal.selection);
    }

    ReactEditor.focus(editor);

    hideVisibleModal();
  }, [editor, visibleModal]);

  return (
    <>
      <MenuButtonBase
        icon={IconType.Sparkles}
        isActive={isMenuButtonActive(editor, "ai")}
        isDisabled={props.isDisabled}
        onMouseDown={onClick}
      />
      {!!visibleModal && <AiModal isVisible onClose={onClose} onUse={submit} text={visibleModal.text} />}
    </>
  );
};
export default AiButton;
